import React, { createContext, useState } from "react";

const UserContext = createContext();

export function UserContextProvider({ children }) {
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData") || "{}")
  );
//console.log(userData,"local")
  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
}
export default UserContext;
